import axios from 'axios'

const generalServices = {
  saveUserPreferences: ({ storeId, userId, preferences }) =>
    axios.put(`${import.meta.env.VITE_HOST}/stores/${storeId}/users/${userId}/preferences`, preferences),
  editUserProfile: ({ user }) => axios.put(`${import.meta.env.VITE_HOST}/me`, user),
  changePassword: params =>
    axios.post(`${import.meta.env.VITE_HOST}/me/change-password`, {
      ...params,
    }),
  getToken: ({ email, password }) => axios.post(`${import.meta.env.VITE_HOST}/token`, { email, password }),
  restorePassword: ({ email }) => axios.post(`${import.meta.env.VITE_HOST}/reset-password`, { email }),
  refreshToken: refreshToken => axios.post(`${import.meta.env.VITE_HOST}/token/refresh`, { refresh: refreshToken }),
  signup: ({ storeName, termsAndConditions }) =>
    axios.post(`${import.meta.env.VITE_HOST}/signup`, {
      store_name: storeName,
      accepts_terms_and_conditions: termsAndConditions,
    }),
  getSocialToken: params => axios.post(`${import.meta.env.VITE_HOST}/token/social`, null, { params }),
}

export default generalServices
